import React, { Component } from 'react';
import { NavMenu } from './NavMenu';
import {Link} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faVk, faWhatsapp} from '@fortawesome/free-brands-svg-icons'
import useMenu from "./useMenu";
import { YMInitializer } from 'react-yandex-metrika';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div style={{display: "flex", flexDirection: "column", minHeight: "100vh"}}>
        <YMInitializer accounts={[ Number(process.env.REACT_APP_YM_COUNTER) || 99515351 ]} options={{webvisor: true}} />
        <NavMenu />
        <main style={{flex: "1"}}>
          {this.props.children}
        </main>
        <footer>
          <div className="d-flex flex-column align-items-center">
            <div className="d-flex justify-content-around w-75" style={{maxWidth: 600}}>
              <Link to="catalog">Каталог</Link>
              <Link to="#" onClick={(e) => { e.preventDefault(); useMenu(null) }}>Контакты</Link>
            </div>
            <div className="d-flex justify-content-around w-75 mt-4" style={{maxWidth: 600, alignItems: "center"}}>
              <p className="mb-0" style={{fontSize: 14, opacity: 0.7}}>ICandy Russia {new Date().getFullYear()}</p>
              <span>
                <Link to="https://vk.com/icandyrussia" className="me-3" aria-label="VK">
                  <FontAwesomeIcon icon={faVk} size="lg" />
                </Link>
                <Link to="https://wa.me/79150553034" aria-label="WhatsApp">
                  <FontAwesomeIcon icon={faWhatsapp} size="lg" />
                </Link>
              </span>
              <Link to="info" style={{fontSize: 14, opacity: 0.7}}>
                Пользовательское соглашение
              </Link>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}
